'use strict';

var HTTPService = require('../services/http-service');

var NextPath = {
  save: function () {
    var nextPath =
      this.getAttribute('data-next-path') || this.getAttribute('href') || location.pathname;
    HTTPService.post('/api/cookies/nextPath', { value: nextPath });
  }
};

$('body').on('click tap', '.js-next-path', NextPath.save);
